// 马拉松: 【横琴马拉松】

// 马拉松-数据分析
const MarathonDataAnalyseIndex = () =>
  import(
    /* webpackChunkName: "marathonDataAnalyseIndex" */ '@platfrom/marathon/dataAnalyse/index.vue'
  )

// 马拉松-报名数据
const MarathonSignupIndex = () =>
  import(
    /* webpackChunkName: "marathonSignupIndex" */ '@platfrom/marathon/signup/index.vue'
  )

// 马拉松-赛时成绩
const MarathonGamesTimeResultsIndex = () =>
  import(
    /* webpackChunkName: "marathonGamesTimeResultsIndex" */ '@platfrom/marathon/gamesTimeResults/index.vue'
  )

// 马拉松-直播监看
const MarathonLiveMonitoringIndex = () =>
  import(
    /* webpackChunkName: "marathonLiveMonitoringIndex" */ '@platfrom/marathon/liveMonitoring/index.vue'
  )

// 马拉松-视频切片-摄像机位
const MarathonVideoSectionCameraIndex = () =>
  import(
    /* webpackChunkName: "marathonVideoSectionCameraIndex" */ '@platfrom/marathon/videoSection/cameraIndex.vue'
  )

// 马拉松-视频切片-运动员切片
const MarathonVideoSectionPlayerIndex = () =>
  import(
    /* webpackChunkName: "marathonVideoSectionPlayerIndex" */ '@platfrom/marathon/videoSection/playerIndex.vue'
  )

// 马拉松-视频集锦-集锦设置
const MarathonVideoCollectionSettingIndex = () =>
  import(
    /* webpackChunkName: "marathonVideoCollectionSettingIndex" */ '@platfrom/marathon/videoCollection/settingIndex.vue'
  )

// 马拉松-视频集锦-运动员集锦
const MarathonVideoCollectionPlayerIndex = () =>
  import(
    /* webpackChunkName: "marathonVideoCollectionPlayerIndex" */ '@platfrom/marathon/videoCollection/playerIndex.vue'
  )

// 马拉松-播出单
const MarathonBroadcastListIndex = () =>
  import(
    /* webpackChunkName: "CommonPageBroadcastListIndex" */ '@platfrom/commonPage/broadcastList/index.vue'
  )

// 马拉松-数据包装
const MarathonDataPackagListIndex = () =>
  import(
    /* webpackChunkName: "CommonPageDataPackagListIndex" */ '@platfrom/commonPage/dataPackagList/index.vue'
  )

// 马拉松-节目单
const MarathonProgramListIndex = () =>
  import(
    /* webpackChunkName: "CommonPageProgramListIndex" */ '@platfrom/commonPage/programList/index.vue'
  )

export default {
  MarathonDataAnalyseIndex,
  MarathonSignupIndex,
  MarathonGamesTimeResultsIndex,
  MarathonLiveMonitoringIndex,
  MarathonVideoSectionCameraIndex,
  MarathonVideoSectionPlayerIndex,
  MarathonVideoCollectionSettingIndex,
  MarathonVideoCollectionPlayerIndex,
  MarathonBroadcastListIndex,
  MarathonDataPackagListIndex,
  MarathonProgramListIndex,
}
